import { createAction } from 'redux-actions';
import {
  PROCESSING,
  NEXT_PAGE_PROCESSING,
  GET_BLOGS,
  GET_BLOGS_RESULT,
  GET_BLOGS_TOPIC_FACETS,
  GET_BLOGS_TOPIC_FACETS_RESULT,
} from './constants';

export const processing = createAction(PROCESSING);
export const nextPageProcessing = createAction(NEXT_PAGE_PROCESSING);
export const getBlogs = createAction(GET_BLOGS);
export const getBlogsResult = createAction(GET_BLOGS_RESULT);
export const getBlogsTopicFacets = createAction(GET_BLOGS_TOPIC_FACETS);
export const getBlogsTopicFacetsResult = createAction(
  GET_BLOGS_TOPIC_FACETS_RESULT,
);
